export const checkCustomer = (cuscode) => {
	return ['FNG23-096355', 'FNGA1-096355', 'FTR23-106245'].includes(cuscode)
}
